import React, { useState, useEffect, useRef, useCallback ,memo} from "react";
import { Card, Container, Modal, Alert } from "react-bootstrap";
import Search from "../../Search/Search";
import UserDetails from "./UserDetails";
import { Divider } from "@mui/material";
import UserlistWrapper from "./style";
import { useMedia } from "react-use";
import CloseIcon from "@mui/icons-material/Close";

function areEqual(prevProps, nextProps) {
  // Only re‑render this card if its “active” status actually changes
  const prevIsActive = prevProps.memnberList.userId === prevProps.active;
  const nextIsActive = nextProps.memnberList.userId === nextProps.active;

  // Or if the actual member object changed (unlikely unless list updates)
  const sameUser = prevProps.memnberList.userId === nextProps.memnberList.userId;

  return sameUser && prevIsActive === nextIsActive;
}

const UserCard = ({
  memnberList,
  setsubUserPermission,
  setInvitepending,
  index,
  setDeleteUser,
  CardShow,
  setactive,
  active, // now a boolean
  responsiveCard,
}) => {

  const checkPendingInvite = () => {
    if (memnberList.status === "Unverified") {
      setInvitepending(true);
    }
  };

 
  // useEffect(() => {
  //   let hex = Math.floor(Math.random() * 0xffffff);
  //   let color = "#" + hex.toString(16);
  //   setProfileColor(color);
  // }, []);

  const profileColorRef = useRef(
   "#" + Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, "0")
 );
 const profileColor = profileColorRef.current;

  return (
    <div
      className={
        responsiveCard
          ? "my-1"
          : active
          ? "active-card my-1"
          : "my-1"
      }
      style={{ cursor: "pointer", padding: "15px" }}
      onClick={() => {
        setsubUserPermission(memnberList);
        setDeleteUser(index);
        setInvitepending(memnberList.status === "Unverified");
        CardShow();
        setactive(memnberList.userId);
      }}
    >
      <div style={{ display: "inline-flex" }}>
        <div
          className="team-name-circle me-2"
          style={{ background: profileColor }}
        >
          <center>{memnberList.personname[0]}</center>
        </div>
        <div className="box mb-2">
          {memnberList.personname}
          <div className="userid-box mt-1" style={{ wordBreak: "break-all" }}>
            {memnberList.userId}
          </div>
        </div>
      </div>
      {memnberList.status === "Unverified" ? (
        <span
          className="float-end"
          style={{ color: "#4EB6EE", fontSize: "12px" }}
        >
          Pending invite
        </span>
      ) : null}
    </div>
  );
};
export const MemoizedUserCard = memo(UserCard, areEqual);

const UserList = ({
  alertMessage,
  setAlertMessage,
  showAlertBox,
  setShowAlertBox,
  memberDetails,
  setShowNoUser,
  setMemberDetails,
  subUserPermission,
  setsubUserPermission,
  setactive,
  active,
}) => {
  const [invitePending, setInvitepending] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [cardshow, setCardShow] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const userRefs = useRef([]);

  useEffect(() => {
    setTimeout(() => {
      setAlertMessage("");
      setShowAlertBox(false);
    }, 2500);
  }, [showAlertBox]);

  const CardClose = () => setCardShow(false);
  const CardShow = () => setCardShow(true);
  const responsiveCard = useMedia("(max-width: 767px)");

  const handleSearch = (value) => {
    setSearchValue(value);
    setSelectedIndex(0); // Reset selection on search
  };

  // Filtered user list
  const filteredUsers = memberDetails.filter((memnberList) => {
    let personname = memnberList.personname;
    return personname.toLowerCase().includes(searchValue.toLowerCase());
  });

  // Select user by index and update details
  const selectUserByIndex = (idx) => {
    const user = filteredUsers[idx];
    if (user) {
      setsubUserPermission(user);
      setDeleteUser(idx);
      // setactive(user.userId); // REMOVE THIS
      setInvitepending(user.status === "Unverified");
      // CardShow(); // keep commented
      if (userRefs.current[idx]) {
        userRefs.current[idx].scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  };

  // Handle keyboard navigation
  const handleKeyDown = useCallback(
    (e) => {
      if (filteredUsers.length === 0) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => {
          const next = Math.min(prev + 1, filteredUsers.length - 1);
          if (next !== prev) {
            selectUserByIndex(next);
          }
          return next;
        });
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => {
          const next = Math.max(prev - 1, 0);
          if (next !== prev) {
            selectUserByIndex(next);
          }
          return next;
        });
      } else if (e.key === "Enter") {
        e.preventDefault();
        // Open modal for selected user and set active
        setactive(filteredUsers[selectedIndex].userId);
        CardShow();
      }
    },
    [filteredUsers, selectedIndex]
  );

  // Focus the user list for keyboard navigation
  const listContainerRef = useRef(null);
  useEffect(() => {
    const ref = listContainerRef.current;
    if (ref) {
      ref.addEventListener("keydown", handleKeyDown);
      ref.tabIndex = 0; // Make it focusable
    }
    return () => {
      if (ref) ref.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  // Ensure the list container is focused for keyboard navigation
  useEffect(() => {
    if (listContainerRef.current) {
      listContainerRef.current.focus();
    }
  }, [filteredUsers]);

  return (
    <div>
      {showAlertBox && (
        <Alert
          variant="success"
          className="text-center alert-sucess alert mt-3 mb-1"
          dismissible
          closeVariant="white"
          onClick={(e) => setShowAlertBox(false)}
        >
          {alertMessage}
        </Alert>
      )}
      <UserlistWrapper>
        <Container fluid>
          <div className="user_data_container">
            <div className="user_id_lists_card">
              <div className="card-background mt-1">
                <div className="scrollbar_custom">
                  <div
                    className="user-namelist d-flex flex-column"
                    ref={listContainerRef}
                    style={{ outline: "none" }}
                  >
                    <Card className="card-bd">
                      <div className="userlist-header">
                        <div className="Userlist-Search">
                          <span className="mt-1 mx-2">Filter:</span>
                          <Search
                            userFilter="userFilter"
                            type="userFilter"
                            placeholder="Search "
                            handleSearch={handleSearch}
                          />
                        </div>
                      </div>
                      <Card.Body style={{ padding: "0px" }}>
                        {filteredUsers.map((memnberList, index) => {
                          return (
                            <div
                              style={{ background: "transparent" }}
                              key={memnberList.userId} 
                              ref={el => userRefs.current[index] = el}
                            >
                              <Divider className={"divider" + index} />
                              <div
                                className={
                                  (index === selectedIndex ? "active-card " : "") + "list-card"
                                }
                                tabIndex={-1}
                                onClick={() => {
                                  setSelectedIndex(index);
                                  setsubUserPermission(memnberList);
                                  setDeleteUser(index);
                                  setactive(memnberList.userId); // Only update active on click
                                  setInvitepending(memnberList.status === "Unverified");
                                  CardShow(); // Only open modal on click
                                }}
                              >
                                <UserCard
                                  memnberList={memnberList}
                                  setsubUserPermission={setsubUserPermission}
                                  setInvitepending={setInvitepending}
                                  index={index}
                                  setDeleteUser={setDeleteUser}
                                  CardShow={CardShow}
                                  setactive={setactive}
                                  active={index === selectedIndex} // Pass as boolean
                                  responsiveCard={responsiveCard}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
            <div className="user_details_lists_card">
              {responsiveCard ? (
                <Modal
                  show={cardshow}
                  onHide={CardClose}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <div className="p-2" style={{ color: "#4EB6EE" }}>
                    <CloseIcon
                      className=" mt-1"
                      onClick={CardClose}
                      style={{
                        color: "#4EB6EE",
                        cursor: "pointer",
                        float: "right",
                      }}
                    />
                    <UserDetails
                      setShowNoUser={setShowNoUser}
                      setsubUserPermission={setsubUserPermission}
                      setDeleteUser={setDeleteUser}
                      setMemberDetails={setMemberDetails}
                      memberDetails={memberDetails}
                      setShowAlertBox={setShowAlertBox}
                      subUserPermission={subUserPermission}
                      invitePending={invitePending}
                      setAlertMessage={setAlertMessage}
                      deleteUser={deleteUser}
                      setactive={setactive}
                    />
                  </div>
                </Modal>
              ) : (
                <div>
                  <div className="">
                    <UserDetails
                      setShowNoUser={setShowNoUser}
                      setsubUserPermission={setsubUserPermission}
                      setDeleteUser={setDeleteUser}
                      setMemberDetails={setMemberDetails}
                      memberDetails={memberDetails}
                      setShowAlertBox={setShowAlertBox}
                      subUserPermission={subUserPermission}
                      invitePending={invitePending}
                      setAlertMessage={setAlertMessage}
                      deleteUser={deleteUser}
                      setactive={setactive}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Container>
      </UserlistWrapper>
    </div>
  );
};

export default UserList;
